import logo from "./logo/crm.png";

import ribbon from "./artwork/ribbon.svg";
import avatarPlaceholder from "./artwork/avatar-placeholder.png";
import cardBackground from "./artwork/card-background.png";

import community_marker from "./marker/community-marker.png";
import school_marker from "./marker/school-marker.png";
import university_marker from "./marker/university-marker.png";
import default_marker from "./marker/marker-icon.png";
export {
  default_marker,
  logo,
  ribbon,
  avatarPlaceholder,
  cardBackground,
  community_marker,
  school_marker,
  university_marker,
};
